import { isProd } from '../utils/util';

const baseUrl = isProd() ? "https://fe-bp-user-coupon-v4.ccrgt.com" : "https://t-fe-bp-user-coupon-v4.ccrgt.com";
// const baseUrl = isProd() ? "https://fe-bp-user-coupon-v4.ccrgt.com" : "http://127.0.0.1:7001";

// 用户发券
export const activityGrantUrl = `${baseUrl}/activity/grant`;

// 查询是否已经发券
export const isGrantUrl = `${baseUrl}/activity/isGrant`;
